import { ServiceApi } from '../../utils/auth'

const state = {
    settings: [],
    loading: false,
    error: null,
}

const actions = {
    async fetchSettings({ commit }, payload) {
        commit('settingsBegin')
        try {
            const resp = await ServiceApi.get(`/api/config`, payload);
            commit('settingsSuccess', true)
            commit("SET_SETTINGS", resp.data);
            return resp.data;
        } catch (error) {
            commit('settingsErr', error)
            return error
        }
    },
    async settingsCreateUpdate({ commit }, payload) {
        commit('settingsBegin')
        try {
            if (payload.id) {
                const resp = await ServiceApi.put(`/api/config/${payload.id}`, payload);
                commit('settingsSuccess', true)
                return resp.data;
            } else {
                const resp = await ServiceApi.post("/api/config", payload);
                commit('settingsSuccess', true)
                return resp.data;
            }
        } catch (error) {
            commit('settingsErr', error)
            return error
        }
    },
    async settingsDelete({ commit }, id) {
        commit('settingsBegin')
        try {
            const resp = await ServiceApi.delete(`/api/config/${id}`);
            commit('settingsSuccess', true)
            return resp.data;
        } catch (error) {
            commit('settingsErr', error)
            return error
        }
    },
}

const getters = {
    getSettings: state => state.settings,
    settingsLoading: (state) => state.loading,
}

const mutations = {
    SET_SETTINGS(state, payload) {
        state.settings = payload.data
    },
    settingsBegin(state) {
        state.loading = true
    },
    settingsSuccess(state) {
        state.loading = false
    },
    settingsErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
